/*
 *  Document   : app.js
 *  Author     : pixelcave
 *  Description: Main entry point
 *
 */
// Import required modules

import './bootstrap';
import 'bootstrap-maxlength';

import 'select2/dist/js/i18n/en.js';
import { english } from 'flatpickr/dist/l10n/default.js';
import 'summernote/dist/summernote';

// Import required modules
import Tools from './modules/tools';
import Helpers from './modules/helpers';
import Template from './modules/template';
import { _delete, toggle } from '../components/actions';

import datatablesLang from '../locals/en/datatables.en.json';
import swalLanguage from '../locals/en/sweetalert.json';

// App extends Template
export default class App extends Template {
  /*
   * Auto called when creating a new instance
   *
   */
  constructor() {
    super();
  }

  /*
   *  Here you can override or extend any function you want from Template class
   *  if you would like to change/extend/remove the default functionality.
   *
   *  This way it will be easier for you to update the module files if a new update
   *  is released since all your changes will be in here overriding the original ones.
   *
   *  Let's have a look at the _uiInit() function, the one that runs the first time
   *  we create an instance of Template class or App class which extends it. This function
   *  inits all vital functionality but you can change it to fit your own needs.
   *
   */

  /*
   * EXAMPLE #1 - Removing default functionality by making it empty
   *
   */

  //  _uiInit() {}


  /*
   * EXAMPLE #2 - Extending default functionality with additional code
   *
   */

  //  _uiInit() {
  //      // Call original function
  //      super._uiInit();
  //
  //      // Your extra JS code afterwards
  //  }

  /*
   * EXAMPLE #3 - Replacing default functionality by writing your own code
   *
   */

  //  _uiInit() {
  //      // Your own JS code without ever calling the original function's code
  //  }
}


$.extend($.fn.dataTable.defaults, {
    responsive: true,
    autoWidth: false,
    wrapper: 'dataTables_wrapper dt-bootstrap4',
    filterInput: 'form-control form-control-sm',
    lengthSelect: 'form-control form-control-sm',
    language: datatablesLang,
    dom: `<'row'<'col-sm-12'<'text-center bg-body-light py-2 mb-2'B>>>
        <'row'<'col-sm-12 col-md-6'l><'col-sm-12 col-md-6'f>><'row'<'col-sm-12'<'dt-processing'><'table-responsive't>>><'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'p>>`,
    fnPreDrawCallback: () => {
      $('.dt-processing').show();
    },
    fnDrawCallback: () => {
      $('.dt-processing').hide();
      $('.js-tooltip:not(.js-tooltip-enabled)').tooltip({
        placement: 'left',
      });
      window.session.timeout.reset();
    },
  });

  Handlebars.registerHelper('equal', require('handlebars-helper-equal'));
  // Once everything is loaded
  jQuery(() => {
    // Create a new instance of App
    $.fn.select2.defaults.set('language', 'hu');
    $.fn.select2.defaults.set('ajax--delay', 250);

    autosize($('textarea'));

    // Create a new instance of App
    window.One = new App();

    flatpickr.localize(english);

    window.One.helpers([
      'select2',
      'core-bootstrap-tooltip',
      'flatpickr',
      'notify',
      'magnific-popup',
      'maxlength',
    ]);

    $('[js-sortable]').sortable({
      handle: '.handle',
      cursor: 'move',
    });

    $('[js-sortable-y]').sortable({
      axis: 'y',
      handle: '.handle',
      cursor: 'move',
    });

    $.ajaxSetup({
      headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') },
      complete: () => window.session.timeout.reset(),
      error: jqXHR => {
        if ([422].includes(jqXHR.status)) {
          return;
        }

        Swal.fire({
          title: swalLanguage.ajax_error,
          html: `
            <div>${jqXHR.statusText}</div>
            <div>${jqXHR.responseJSON.message}</div>
          `,
          icon: 'error',
        });

        $('[js-listing-table]')
          .DataTable()
          .ajax.reload(false);
      },
      statusCode: {
        401: () => (location.href = '/'),
        422: jqXHR => {
          const formErrors = jqXHR.responseJSON.errors;

          for (const fieldName in formErrors) {
            const field = $(`[name=${fieldName}]`);
            $('.invalid-feedback', field.parent())
              .html(formErrors[fieldName][0])
              .show();
            field.addClass('is-invalid');
          }

          Swal.fire({
            title: swalLanguage.could_not_processed,
            icon: 'error',
            html: swalLanguage.validation_error + ` <div><code>${JSON.stringify(
              formErrors
            )}</code></div>`,
          });
        },
      },
    });

    _delete.run();
    toggle.run();
  });
